import { createFileRoute, Outlet } from '@tanstack/react-router';

import Layout from '@/screens/chat/apps/id/layout';

export const Route = createFileRoute('/_app/_chat/apps/$id')({
  component: LayoutRoute,
});

function LayoutRoute() {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}
